import * as React from "react"
import { DateMultiPickerSeeker } from "ui-seeker/core"


export default function DateSpecificDays({ ...props }) {

	const myProps = {
		label: '',
		wrapperClass: `wrapper-date-specific-days ${props.disabled && 'disabled'} ${props.wrapperClassName}`,
		minDate: new Date(),
		weekStartDayIndex: 1,
		...props
	}

    return <DateMultiPickerSeeker {...myProps} />
}